import { ItemsPerPage } from './items-per-page/items-per-page';
import { PaginationControl } from './pagination-control/pagination-control';
import { IPanelProps } from '../interfaces/interfaces';
import { useAppSelector } from '../data/store';
import { ITEMS_PER_PAGE_1 } from '../services/list-page-provider';

/**
 * jPList bottom panel.
 */
export const BottomPanel = (props: IPanelProps) => {

    const pagination = useAppSelector(store => store.pagination);

    return (
        <div className="my-10 flex items-center w-full">

            {
                pagination && pagination.pagesNumber > 1 &&
                <div className="w-full md:w-auto md:mr-4 flex justify-center md:justify-start">
                    <PaginationControl/>
                </div>
            }

            {
                pagination && pagination.itemsNumber >= ITEMS_PER_PAGE_1 &&
                <div className="ml-4 ml-auto hidden md:block">
                    <ItemsPerPage />
                </div>
            }
        </div>
    )
};